export const serviceItemOrderStateEnum = [
    {
        stateId: "UNPAID",
        stateName: "待支付"
    },
    {
        stateId: "PENDING",
        stateName: "待确认"
    },
    {
        stateId: "CONFIRMED",
        stateName: "已接单"
    },
    {
        stateId: "SERVING",
        stateName: "服务中"
    },
    {
        stateId: "COMPLETED",
        stateName: "已完成"
    },
    {
        stateId: "CANCELLED",
        stateName: "已取消"
    },
    {
        stateId: "CLOSED",
        stateName: "已关闭"
    },
    {
        stateId: "REJECTED",
        stateName: "已拒绝"
    },
    {
        stateId: "REFUNDING",
        stateName: "退款中"
    },
    {
        stateId: "REFUNDED",
        stateName: "已退款"
    },
    {
        stateId: "CUSTOMER_SERVICE",
        stateName: "客服介入"
    }
]
